import { Injectable } from '@angular/core';
import { UAParser } from 'ua-parser-js';

@Injectable({ providedIn: 'root' })
export class BrowserDetectService {
  private browserDetails: UAParser.IResult;

  public isIOS(): boolean {
    if (!this.browserDetails) {
      this.browserDetails = this.getBrowserResult();
    }
    return this.browserDetails.os.name === 'iOS';
  }

  public isSafariBrowserOrWebkit(): boolean {
    if (!this.browserDetails) {
      this.browserDetails = this.getBrowserResult();
    }
    return (
      this.browserDetails.browser.name === 'Mobile Safari' ||
      this.browserDetails.browser.name?.toLowerCase() === 'webkit'
    );
  }

  private getBrowserResult(): UAParser.IResult {
    const parser = new UAParser(navigator.userAgent);
    const result = parser.getResult();
    return result;
  }
}
